import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconPropsAll } from 'common/icon/icon.js';
import { ListInlineItemMockProps, ListInlineValueMock } from './list-inline-value.js';

export type ListInlineIconProps = IconPropsAll & {
  title: string;
  titleSecondary?: string;
} & ListInlineItemMockProps;

/** Wrap with className="grid-list" */
export const ListInlineIconItem = (props: ListInlineIconProps) => {
  return (
    <IconWithText {...props} classes="IconWithText--vCenter IconWithText--small">
      <ListInlineItem lineBreak={props.lineBreak} title={props.title} titleSecondary={props.titleSecondary}>
        {props.children}
      </ListInlineItem>
    </IconWithText>
  );
};

export const ListInlineItem = ({
  title,
  titleSecondary,
  classes,
  ...props
}: ListInlineItemMockProps & { title: string; titleSecondary?: string; classes?: string }) => {
  return (
    <div
      className={classNames(
        'u-mT-0 u-mB-0 u-flex u-flexJustifyBetween u-flexAlignItemsCenter',
        {
          'u-mB-xxs': !!titleSecondary,
        },
        classes,
      )}
    >
      <span className={classNames('u-flexGrow-0 u-text-sm')}>
        <span className="u-block u-textNoWrap">{title}</span>
        {titleSecondary && <span className="u-block u-textNoWrap u-textTitleSecondary">{titleSecondary}</span>}
      </span>
      <ListInlineValueMock {...props} />
    </div>
  );
};
